export class UserRoles {

  public static all: string = '*';
  public static guest: string = 'guest';
  public static user: string = 'user';

}
